<template>
  <div id="delivery-man-detail" v-visibility-change="visibilityChange">
    <order-status-bar :status-level="order.customIndicators.statusLevel" :progress-color="progressColor" />
    <el-row v-if="isEstimatedTime" :gutter="24">
      <el-col justify="end" :span="24" class="display-flex">
        <h2 class="folio-eta-label">
          {{ estimatedTime }}
        </h2>
        <span class="driver-man-label-eta">
          {{ this.$t('driver.timeToDelivery') }}
        </span>
      </el-col>
    </el-row>
    <el-row :gutter="24" class="mt-10">
      <el-col :span="5">
        <avatar-interface :src="driverPhoto" :size="size" class="mr-16" />
      </el-col>
      <el-col :span="15">
        <el-row>
          <el-col :span="24" class="mt-15">
            <transition name="fade" mode="out-in">
              <span v-if="order.customIndicators.statusMessage" class="display-block driver-man-label">
                {{ order.customIndicators.statusMessage }}
              </span>
            </transition>
          </el-col>
          <el-col v-if="isOnSiteCountDown" justify="end" :span="8">
            <h2 class="folio-eta-label">
              {{ countDown.time }}
            </h2>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <span class="display-block folio-description">
              {{ folio }}
            </span>
          </el-col>
          <el-col v-if="isETAAlerts" :span="16">
            <span class="mt-10 display-block folio-eta-description">
              {{ ETAAlertIndicator.message }}
            </span>
          </el-col>
          <el-col v-if="isOnSiteCountDown" :span="16">
            <span class="mt-10 display-block folio-eta-description">
              {{ countDown.message }}
            </span>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="4">
        <a v-if="waPhone" :href="`https://wa.me/${waPhone}`" target="_blank">
          <img src="@/assets/images/wa.png" class="icon-wa">
        </a>
      </el-col>
    </el-row>
    <el-row :gutter="24" class="mt-10">
      <el-col :span="24" class="text-center">
        <el-button
          :disabled="order.customIndicators.isDisabledDetailButton"
          :style="`--background-color: ${buttonColor};`"
          class="button-send"
          type="primary"
          @click="onViewStatus">
          {{ $t('general.viewFolioStatus') }}
        </el-button>
      </el-col>
      <el-col :span="24">
        <div class="text-center delivery-powered-by pt-10">
          <a :href="url" target="_blank"> {{ poweredBy }} </a>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
// Components
import OrderStatusBar from '@/components/Orders/OrderStatusBar'

// Mixins
import DeliveryDetailMethods from '@/utils/mixins/deliveryDetailMethods'

export default {
  name: 'DeliveryManDetail',
  mixins: [DeliveryDetailMethods],
  components: {
    OrderStatusBar
  }
}
</script>

